import { render } from "./Form.vue?vue&type=template&id=60548fd1&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=60548fd1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60548fd1"

export default script